
export const ContentBottomGradient = () => {
    return (
        <div className="z-10 absolute bottom-0 left-0 w-full h-[50px] pointer-events-none" style={{ background: 'linear-gradient(to bottom, transparent, var(--bcbackground-0, #fff))' }} />
    )
}